"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWizardMethods = void 0;
var forwardStep_1 = require("./forwardStep");
var goToStep_1 = require("./goToStep");
var initialize_1 = require("./initialize");
var jumpSteps_1 = require("./jumpSteps");
var nextStep_1 = require("./nextStep");
var previousStep_1 = require("./previousStep");
var getWizardLength_1 = require("./getWizardLength");
var getWizardIndex_1 = require("./getWizardIndex");
var getInitialStep_1 = require("./getInitialStep");
var getWizardMethods = function (args) {
    return ({
        forwardStep: forwardStep_1.forwardStep({
            poppedHistory: args.poppedHistory,
            setHistory: args.setHistory,
            setPoppedHistory: args.setPoppedHistory
        }),
        goToStep: goToStep_1.goToStep({ setHistory: args.setHistory }),
        history: args.history,
        initialize: initialize_1.initialize({
            setHistory: args.setHistory,
            initialStep: getInitialStep_1.getInitialStep({ options: args.options, wizardType: args.wizardType })
        }),
        jumpSteps: jumpSteps_1.jumpSteps({ wizardType: args.wizardType, options: args.options, setHistory: args.setHistory }),
        nextStep: nextStep_1.nextStep({
            wizardType: args.wizardType,
            history: args.history,
            setHistory: args.setHistory,
            setPoppedHistory: args.setPoppedHistory,
            options: args.options
        }),
        nForwardSteps: args.poppedHistory.length,
        nPreviousSteps: args.history.length - 1,
        previousStep: previousStep_1.previousStep({
            history: args.history,
            setHistory: args.setHistory,
            setPoppedHistory: args.setPoppedHistory
        }),
        stepIndex: getWizardIndex_1.getWizardIndex({ options: args.options, step: args.history[args.history.length - 1] }),
        wizardLength: getWizardLength_1.getWizardLength({ options: args.options }),
    });
};
exports.getWizardMethods = getWizardMethods;
//# sourceMappingURL=getWizardMethods.js.map